import { Icon, Table } from "semantic-ui-react";

import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Flex from "../../../../components/Flex/Flex";

export default function FormFieldArrayTable({ header, name, filter, children, onAppend, ...props }) {
	const { t } = useTranslation();
	const { watch, formState } = useFormContext();

	const { swap, append, remove } = useFieldArray({
		name,
		...props,
	});

	const data = watch(name);

	const style = {
		background: "none",
		border: !data?.length && "none",
	};

	const onAdd = () => append(onAppend ? onAppend() : {});

	return (
		<Table padded {...props}>
			{header && (
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell style={style}>{header}</Table.HeaderCell>
						<Table.HeaderCell style={style} collapsing textAlign="right">
							<Icon link fitted name="plus" onClick={onAdd} disabled={formState.disabled} />
						</Table.HeaderCell>
					</Table.Row>
				</Table.Header>
			)}

			<Table.Body>
				{data
					?.filter((row) => (!filter ? true : filter(row)))
					.map((row, index, array) => (
						<Table.Row key={index}>
							<Table.Cell>{children(row, index)}</Table.Cell>
							<Table.Cell collapsing>
								<Flex gap={10}>
									<Icon
										name="arrow up outline"
										link={index !== 0}
										disabled={index === 0 || formState.disabled}
										onClick={() => swap(index, index - 1)}
										style={{ height: "auto" }}
									/>

									<Icon
										name="arrow down outline"
										link={index !== array.length - 1}
										disabled={index === array.length - 1 || formState.disabled}
										onClick={() => swap(index, index + 1)}
										style={{ height: "auto" }}
									/>

									<Icon
										link
										name="minus outline"
										onClick={() => remove(index)}
										disabled={formState.disabled}
										style={{ height: "auto" }}
									/>
								</Flex>
							</Table.Cell>
						</Table.Row>
					))}
			</Table.Body>

			{!header && (
				<Table.Footer>
					<Table.Row>
						<Table.HeaderCell
							colSpan={2}
							textAlign="center"
							disabled={formState.disabled}
							onClick={formState.disabled ? undefined : onAdd}
							style={{ ...style, cursor: formState.disabled ? "default" : "pointer" }}
						>
							<Icon name="plus" />
							{t("add", "Add")}
						</Table.HeaderCell>
					</Table.Row>
				</Table.Footer>
			)}
		</Table>
	);
}
